import { expValEquals } from '@confluence/feature-experiments';

/**
 * Shallow-equality check used by React.memo when the experiment is enabled.
 * When the experiment is disabled, returns false so React always re-renders
 * (preserves the pre-experiment behaviour).
 */
export const arePropsShallowEqualWhenMemoRowsEnabled = <P extends Record<string, unknown>>(
	prev: Readonly<P>,
	next: Readonly<P>,
): boolean => {
	if (!expValEquals('confluence_comments_panel_memo_rows', 'isEnabled', true)) {
		return false;
	}

	if (prev === next) {
		return true;
	}

	const prevKeys = Object.keys(prev);
	const nextKeys = Object.keys(next);

	if (prevKeys.length !== nextKeys.length) {
		return false;
	}

	for (const key of prevKeys) {
		if (!Object.prototype.hasOwnProperty.call(next, key)) {
			return false;
		}
		if (prev[key] !== next[key]) {
			return false;
		}
	}

	return true;
};
